import React from 'react';

import {Run} from '../../../util/runTypes';
import {MoveRunDrawerContents} from './MoveRunDrawerContents';
import {Drawer} from './MoveRunDrawerPieces';

type MoveRunDrawerProps = {
  entityName: string;
  isInReport: boolean | undefined;
  onClose: () => void;
  /** called when move runs process completes. does not fire on failure. */
  onMovedRuns: () => void;
  open: boolean;
  projectName: string;
  runs: Run[];
};
export function MoveRunDrawer({
  entityName,
  isInReport,
  open,
  onClose,
  onMovedRuns,
  projectName,
  runs,
}: MoveRunDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose}>
      <MoveRunDrawerContents
        entityName={entityName}
        isInReport={isInReport}
        onClose={onClose}
        onMovedRuns={onMovedRuns}
        projectName={projectName}
        runs={runs}
      />
    </Drawer>
  );
}
